export default __webpack_public_path__ + "static/media/expocebu-2.2539c09d.jpg";